require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/modules/go-to-top-bottom.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/modules/go-to-top-bottom.legacy.js
// module id = 716
// module chunks = 31